// import appinfo from './crait/appinfo'
// import appinfo from './sectone/appinfo'
import appinfo from './vanish/appinfo'

// if you want to change app, you should to remove the comment.
class AppInfo {
  constructor () {
    this.appName = ''
    this.appIcon = ''
    this.backgroundImg = ''
    this.appVersion = ''
    this.genericVersion = true
    this.init()
  }

  init () {
    this.appName = appinfo.appName
    this.appVersion = appinfo.appVersion
    this.genericVersion = appinfo.isGenericVersion
    this.appIcon = appinfo.appIcon
    this.backgroundImg = appinfo.backgroundImg
  }

  getfirstUpperCaseAppName () {
    return this.appName.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
  }

  getAppName () {
    return this.appName
  }

  getAppIcon () {
    return this.appIcon
  }

  getBackgroundImg () {
    return this.backgroundImg
  }

  getAppVersion () {
    return this.appVersion
  }

  isGenericVersion () {
    return this.genericVersion
  }
}

export default new AppInfo()



// WEBPACK FOOTER //
// ./src/appInfo/index.js